import axios from 'axios';
import { BASE_API_URL } from '../constants/env';

export const exportReceipts = async (token, filtersData, filename) => {
    const url = `${BASE_API_URL}/stock-movements/receipt/export`;

    return axios
        .post(
            url,
            { searchRequests: filtersData, fileName: filename },
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            }
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log('Error on exportReceipts call: ', error);
            return error;
        });
};

export const exportStock = async (token, filtersData, filename) => {
    const url = `${BASE_API_URL}/stock/export`;

    return axios
        .post(
            url,
            { searchRequests: filtersData, fileName: filename },
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            }
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log('Error on exportStock call: ', error);
            return error;
        });
};

export const exportIssues = async (token, filtersData, filename) => {
    const url = `${BASE_API_URL}/stock-movements/issue/export`;

    return axios
        .post(
            url,
            { searchRequests: filtersData, fileName: filename },
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            }
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log('Error on exportIssues call: ', error);
            return error;
        });
};

export const exportReceiptsByProviderReport = async (token, filtersData, filename) => {
    const url = `${BASE_API_URL}/stock-movements/receipt/by-provider/export`;

    return axios
        .post(
            url,
            { searchRequests: filtersData, fileName: filename },
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            }
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log('Error on exportReceiptsByProviderReport call: ', error);
            return error;
        });
};

export const exportReceiptsByArticleReport = async (token, filtersData, filename) => {
    const url = `${BASE_API_URL}/stock-movements/receipt/by-article/export`;

    return axios
        .post(
            url,
            { searchRequests: filtersData, fileName: filename },
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            }
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log('Error on exportReceiptsByArticleReport call: ', error);
            return error;
        });
};

export const exportIssuesByVehicleReport = async (token, filtersData, filename) => {
    const url = `${BASE_API_URL}/stock-movements/issue/by-vehicle/export`;

    return axios
        .post(
            url,
            { searchRequests: filtersData, fileName: filename },
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            }
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log('Error on exportIssuesByVehicleReport call: ', error);
            return error;
        });
};

export const exportIssuesByArticleReport = async (token, filtersData, filename) => {
    const url = `${BASE_API_URL}/stock-movements/issue/by-article/export`;

    return axios
        .post(
            url,
            { searchRequests: filtersData, fileName: filename },
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            }
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log('Error on exportIssuesByArticleReport call: ', error);
            return error;
        });
};

export const exportIssueArticleDetailsReport = async (token, filtersData, filename, pathVariables) => {
    const url = `${BASE_API_URL}/stock-movements/issue/article/${pathVariables.articleId}/details/export`;

    return axios
        .post(
            url,
            { searchRequests: filtersData, fileName: filename },
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            }
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log('Error on exportIssueArticleDetailsReport call: ', error);
            return error;
        });
};

export const exportIssueVehicleDetailsReport = async (token, filtersData, filename, pathVariables) => {
    const url = `${BASE_API_URL}/stock-movements/issue/vehicle/${pathVariables.vehicleId}/articles/export`;

    return axios
        .post(
            url,
            { searchRequests: filtersData, fileName: filename },
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            }
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log('Error on exportIssueVehicleDetailsReport call: ', error);
            return error;
        });
};

export const exportReceiptProviderDetailsReport = async (token, filtersData, filename, pathVariables) => {
    const url = `${BASE_API_URL}/stock-movements/receipt/provider/${pathVariables.providerId}/articles/export`;

    return axios
        .post(
            url,
            { searchRequests: filtersData, fileName: filename },
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            }
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log('Error on exportReceiptProviderDetailsReport call: ', error);
            return error;
        });
};

export const exportWorkOrdersReport = async (token, filtersData, filename) => {
    const url = `${BASE_API_URL}/work-orders/export`;

    return axios
        .post(
            url,
            { searchRequests: filtersData, fileName: filename },
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            }
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log('Error on exportWorkOrdersReport call: ', error);
            return error;
        });
};

export const exportIssuesByWorkOrderReport = async (token, filtersData, filename) => {
    const url = `${BASE_API_URL}/stock-movements/issue/by-work-order/export`;

    return axios
        .post(
            url,
            { searchRequests: filtersData, fileName: filename },
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            }
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log('Error on exportIssuesByWorkOrderReport call: ', error);
            return error;
        });
};

export const exportWorkOrderDetailsReport = async (token, filtersData, filename, pathVariables) => {
    const url = `${BASE_API_URL}/stock-movements/issue/work-order/${pathVariables.workOrderId}/articles/export`;

    return axios
        .post(
            url,
            { searchRequests: filtersData, fileName: filename },
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            }
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log('Error on exportWorkOrderDetailsReport call: ', error);
            return error;
        });
};

export const exportInternalServicesReport = async (token, filtersData, filename) => {
    const url = `${BASE_API_URL}/work-orders/performed-works/export`;

    return axios
        .post(
            url,
            { searchRequests: filtersData, fileName: filename },
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            }
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log('Error on exportInternalServicesReport call: ', error);
            return error;
        });
};

export const exportExternalServicesReport = async (token, filtersData, filename) => {
    const url = `${BASE_API_URL}/work-orders/external-works/export`;

    return axios
        .post(
            url,
            { searchRequests: filtersData, fileName: filename },
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            }
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log('Error on exportExternalServicesReport call: ', error);
            return error;
        });
};

export const exportMovementsByMonthReport = async (token, filtersData, filename) => {
    const url = `${BASE_API_URL}/stock-movements/monthly-report/export`;

    return axios
        .post(
            url,
            { searchRequests: filtersData, fileName: filename },
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            }
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log('Error on exportMovementsByMonthReport call: ', error);
            return error;
        });
};
